<template>
  <a-col :span="12">
    <!-- 两边 label 文案一致（原来靠 `(mode)` / `(multiple)` 区分，v29.38 去英文后合并为静态 label） -->
    <a-form-item label="单选多选">
      <a-radio-group
        v-if="field === 'mode'"
        v-model:value="config.mode"
      >
        <a-radio value="default">单选</a-radio>
        <a-radio value="multiple">多选</a-radio>
        <a-radio value="tags">标签</a-radio>
      </a-radio-group>
      <a-radio-group
        v-else
        v-model:value="config.multiple"
      >
        <a-radio :value="false">单选</a-radio>
        <a-radio :value="true">多选</a-radio>
      </a-radio-group>
    </a-form-item>
  </a-col>
</template>

<script setup lang="ts">
/* 单选多选配置（共享）：field='mode' 走 default/multiple/tags 三态，
   field='multiple' 走布尔二态（树/级联类组件）。 */
defineProps<{
  config: any;
  field: 'mode' | 'multiple';
}>();
</script>
